import PropTypes from 'prop-types';
import './styles.scss';

const Tabs = ({
  tabs,
  active,
  onChange,
}) => {
  return (
    <div className='tabs mb-4'>
      {tabs.map((tab) => (
        <div
          key={tab.value}
          className={`tab ${tab.value === active ? 'active' : ''}`}
          onClick={() => onChange(tab.value)}
        >
          {tab?.count !== undefined && (
            <span className='count'>{tab.count > 99 ? '+99' : tab.count}</span>
          )}
          {tab.label}
        </div>
      ))}
    </div>
  );
};

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    count: PropTypes.number,
  })).isRequired,
  active: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default Tabs;
